export const TASK_PROJECT_DEFAULT_COLOR = '#218679'